webpackJsonp([35783957827783],{

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/TFP-logo-header-red.6937adeb.png";

/***/ }),

/***/ 407:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lettuce-grow-fishing-sustainable.f4ddfdb1.jpg";

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lettuce-grow-urban-farming.372f14c0.png";

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/underline-grey.33f1ffb6.png";

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(106);
	
	var _lettuceGrowUrbanFarming = __webpack_require__(117);
	
	var _lettuceGrowUrbanFarming2 = _interopRequireDefault(_lettuceGrowUrbanFarming);
	
	var _lettuceGrowFishingSustainable = __webpack_require__(116);
	
	var _lettuceGrowFishingSustainable2 = _interopRequireDefault(_lettuceGrowFishingSustainable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FromTheBlog = function (_React$Component) {
	    _inherits(FromTheBlog, _React$Component);
	
	    function FromTheBlog(props) {
	        _classCallCheck(this, FromTheBlog);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    FromTheBlog.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'from-the-blog' },
	            _react2.default.createElement(
	                'figure',
	                { className: 'from-the-blog__title' },
	                'From The ',
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    'Blog'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'from-the-blog__content' },
	                this.props.data.edges.map(function (_ref, i) {
	                    var node = _ref.node;
	
	                    return _react2.default.createElement(
	                        'div',
	                        { key: i },
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/blog/' + node.slug, className: 'from-the-blog__read-more' },
	                            _react2.default.createElement(
	                                'figure',
	                                {
	                                    className: 'from-the-blog__image',
	                                    style: node.heroImage && node.heroImage.file ? {
	                                        backgroundImage: 'url(' + node.heroImage.file.url + '?fm=jpg&q=80&w=800&h=800&fl=progressive&fit=thumb&f=face'
	                                    } : {}
	                                },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'from-the-blog__tag' },
	                                    node.category ? node.category.title : ''
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'from-the-blog__text' },
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'from-the-blog__headline' },
	                                node.title
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'from-the-blog__copy' },
	                                node.introductoryQuote ? node.introductoryQuote.introductoryQuote : ''
	                            ),
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: '/blog/' + node.slug, className: 'from-the-blog__read-more' },
	                                'Read More'
	                            )
	                        )
	                    );
	                })
	            )
	        );
	    };
	
	    return FromTheBlog;
	}(_react2.default.Component);
	
	exports.default = FromTheBlog;
	module.exports = exports['default'];

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hero = function (_React$Component) {
	  _inherits(Hero, _React$Component);
	
	  function Hero(props) {
	    _classCallCheck(this, Hero);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { locked: '' };
	    return _this;
	  }
	
	  Hero.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('scroll', this.handleScroll.bind(this));
	  };
	
	  Hero.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('scroll', this.handleScroll.bind(this));
	  };
	
	  Hero.prototype.handleScroll = function handleScroll(event) {
	    // if (event.srcElement.body.scrollTop > window.innerHeight + 100) {
	    //   this.setState({ locked: 'hero--scrolled' });
	    // } else {
	    //   this.setState({ locked: '' });
	    // }
	  };
	
	  Hero.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'hero' },
	      _react2.default.createElement(
	        'div',
	        { className: this.state.locked },
	        _react2.default.createElement('div', { className: 'hero__background' }),
	        _react2.default.createElement('div', { className: 'hero__slogan' }),
	        _react2.default.createElement('div', {
	          alt: this.props.title,
	          title: this.props.title,
	          className: 'hero__overlay'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'hero__title' },
	          this.props.title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'hero__copy' },
	          'Founded by Zooey Deschanel and Jacob Pechenik,',
	          _react2.default.createElement('br', null),
	          'The Farm Project empowers initiatives that reconnect people with food.'
	        )
	      )
	    );
	  };
	
	  return Hero;
	}(_react2.default.Component);
	
	exports.default = Hero;
	;
	module.exports = exports['default'];

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(108);
	
	var _TFPLogoHeaderRed = __webpack_require__(115);
	
	var _TFPLogoHeaderRed2 = _interopRequireDefault(_TFPLogoHeaderRed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var marked = __webpack_require__(12);
	
	exports.default = function (_ref) {
	    var data = _ref.data,
	        _ref$hasLowerPadding = _ref.hasLowerPadding,
	        hasLowerPadding = _ref$hasLowerPadding === undefined ? true : _ref$hasLowerPadding;
	    return _react2.default.createElement(
	        'div',
	        { className: 'main ' + (hasLowerPadding ? 'main__with-lower-padding' : '') },
	        _react2.default.createElement(
	            'div',
	            { className: 'main__content' },
	            _react2.default.createElement(
	                'div',
	                { className: 'main__content__copy' },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'main__content__headline' },
	                    data.mainHeading
	                ),
	                _react2.default.createElement('img', { className: 'main__logo', src: _TFPLogoHeaderRed2.default }),
	                _react2.default.createElement('div', {
	                    className: 'main__content__copy__inner',
	                    dangerouslySetInnerHTML: {
	                        __html: marked(data.mainText.mainText, {
	                            gfm: true,
	                            breaks: true
	                        })
	                    }
	                }),
	                !!data.callToActionText && !!data.callToActionUrl && _react2.default.createElement(
	                    'div',
	                    { className: 'collaborations__link' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: data.callToActionUrl, target: '_blank' },
	                        data.callToActionText,
	                        _react2.default.createElement('i', { className: 'fas fa-chevron-right' })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'main__content__image' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'main__content__image__expander' },
	                    data.imageLinkUrl && data.imageLinkUrl !== 'NONE' ? _react2.default.createElement(
	                        'a',
	                        { href: data.imageLinkUrl, target: '_blank' },
	                        _react2.default.createElement('img', { src: data.mainVideoUrl })
	                    ) : _react2.default.createElement('iframe', { src: data.mainVideoUrl, scrolling: 'no', frameBorder: '0', allowFullScreen: 'true' })
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 108:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsletterSubmitMessage = function NewsletterSubmitMessage(props) {
	  var visibleClass = props.isVisible ? 'newsletter__feedback--visible' : '';
	  var submittedClass = props.submitted ? 'newsletter__feedback--submitted' : '';
	  return _react2.default.createElement(
	    'div',
	    { className: 'newsletter__feedback ' + visibleClass + ' ' + submittedClass },
	    props.message
	  );
	};
	
	exports.default = NewsletterSubmitMessage;
	module.exports = exports['default'];

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underlineGrey = __webpack_require__(118);
	
	var _underlineGrey2 = _interopRequireDefault(_underlineGrey);
	
	var _newsletterSubmitMessage = __webpack_require__(76);
	
	var _newsletterSubmitMessage2 = _interopRequireDefault(_newsletterSubmitMessage);
	
	__webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var encode = function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
	  }).join('&');
	};
	
	var Newsletter = function (_React$Component) {
	  _inherits(Newsletter, _React$Component);
	
	  function Newsletter(props) {
	    _classCallCheck(this, Newsletter);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	
	      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	      if (!re.test(_this.state.email)) {
	        _this.setState({
	          submitResponse: 'Hm, that doesn’t look like a valid e-mail address.',
	          submitResponseIsVisible: true
	        });
	        return;
	      }
	
	      fetch('/', {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	        body: encode({ 'form-name': 'newsletter', email: _this.state.email })
	      }).then(function () {
	        _this.setState({
	          submitted: true,
	          submitResponse: 'Thanks for signing up! We’ll be in touch.',
	          submitResponseIsVisible: true
	        });
	        window.ga('send', {
	          hitType: 'event',
	          eventCategory: 'Newsletter',
	          eventAction: 'Sign Up',
	          eventLabel: _this.props.home ? 'Home' : 'Footer'
	        });
	      }).catch(function (error) {
	        _this.setState({
	          submitResponse: 'Oops... Something went wrong.',
	          submitResponseIsVisible: true
	        });
	      });
	    };
	
	    _this.handleChange = function (e) {
	      var _this$setState;
	
	      return _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
	    };
	
	    _this.state = {
	      email: '',
	      submitted: false,
	      submitResponse: '',
	      submitResponseIsVisible: false
	    };
	
	    _this.resetSubmitMessage = _this.resetSubmitMessage.bind(_this);
	    return _this;
	  }
	
	  /* Here’s the juicy bit for posting the form submission */
	
	
	  Newsletter.prototype.resetSubmitMessage = function resetSubmitMessage() {
	    this.setState({
	      submitResponseIsVisible: false
	    });
	  };
	
	  Newsletter.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'newsletter' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'newsletter__title' },
	        'Sign up for our newsletter',
	        _react2.default.createElement(
	          'span',
	          null,
	          '!'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'newsletter__cta' },
	        'Stay up to date with the latest news from The Farm Project.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          { className: 'newsletter__privacy' },
	          '(Your data is safe. We\u2019d never share it with any third parties.)'
	        )
	      ),
	      _react2.default.createElement(
	        'form',
	        {
	          name: 'newsletter',
	          'data-netlify': 'true',
	          onSubmit: this.handleSubmit,
	          className: 'newsletter__form ' + (this.state.submitted ? 'newsletter__form__submitted' : '')
	        },
	        _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'newsletter' }),
	        _react2.default.createElement('input', {
	          type: 'email',
	          className: 'newsletter__field',
	          placeholder: 'Email address',
	          name: 'email',
	          onChange: this.handleChange,
	          onFocus: this.resetSubmitMessage
	        }),
	        _react2.default.createElement('input', { type: 'submit', className: 'newsletter__button', value: 'Join Us' })
	      ),
	      _react2.default.createElement(_newsletterSubmitMessage2.default, {
	        submitted: this.state.submitted,
	        message: this.state.submitResponse,
	        isVisible: this.state.submitResponseIsVisible
	      })
	    );
	  };
	
	  return Newsletter;
	}(_react2.default.Component);
	
	exports.default = Newsletter;
	module.exports = exports['default'];

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animatedScroll = __webpack_require__(185);
	
	var _arrowDown = __webpack_require__(407);
	
	var _arrowDown2 = _interopRequireDefault(_arrowDown);
	
	__webpack_require__(357);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollButton = function (_React$Component) {
	  _inherits(ScrollButton, _React$Component);
	
	  function ScrollButton() {
	    _classCallCheck(this, ScrollButton);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ScrollButton.prototype.onClick = function onClick() {
	    var mainContent = document.querySelector('.main');
	    (0, _animatedScroll.scrollToY)(mainContent.offsetTop, 1500, 'easeOutSine');
	  };
	
	  ScrollButton.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'scroll-button', onClick: this.onClick },
	      _react2.default.createElement('img', { src: _arrowDown2.default, width: '50%', height: '50%' })
	    );
	  };
	
	  return ScrollButton;
	}(_react2.default.Component);
	
	exports.default = ScrollButton;
	module.exports = exports['default'];

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helmetBuilder = __webpack_require__(19);
	
	var _helmetBuilder2 = _interopRequireDefault(_helmetBuilder);
	
	var _hero = __webpack_require__(74);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _scrollButton = __webpack_require__(174);
	
	var _scrollButton2 = _interopRequireDefault(_scrollButton);
	
	var _main = __webpack_require__(75);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _newsletter = __webpack_require__(77);
	
	var _newsletter2 = _interopRequireDefault(_newsletter);
	
	var _fromTheBlog = __webpack_require__(73);
	
	var _fromTheBlog2 = _interopRequireDefault(_fromTheBlog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	    var data = _ref.data,
	        location = _ref.location;
	    return _react2.default.createElement(
	        'div',
	        { className: 'home' },
	        _react2.default.createElement(_helmetBuilder2.default, { data: data.home.edges[0].node, pathname: location.pathname }),
	        _react2.default.createElement(_hero2.default, { title: 'Know It Or Grow It' }),
	        _react2.default.createElement(_scrollButton2.default, null),
	        data.home.edges[0].node.homePageEntries.map(function (entry, idx) {
	            return _react2.default.createElement(_main2.default, { key: idx, data: entry, hasLowerPadding: idx === data.home.edges[0].node.homePageEntries.length - 1 });
	        }),
	        _react2.default.createElement(_newsletter2.default, { home: true }),
	        _react2.default.createElement(_fromTheBlog2.default, { data: data.fromTheBlog })
	    );
	};
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.scrollToY = scrollToY;
	if (typeof window !== 'undefined') {
	  window.requestAnimFrame = function () {
	    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
	      window.setTimeout(callback, 1000 / 60);
	    };
	  }();
	}
	
	function scrollToY(scrollTargetY, speed, easing) {
	  var scrollY = window.scrollY || document.documentElement.scrollTop,
	      scrollTargetY = scrollTargetY || 0,
	      speed = speed || 2000,
	      easing = easing || 'easeOutSine',
	      currentTime = 0;
	
	  var time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8));
	
	  var easingEquations = {
	    easeOutSine: function easeOutSine(pos) {
	      return Math.sin(pos * (Math.PI / 2));
	    },
	    easeInOutSine: function easeInOutSine(pos) {
	      return -0.5 * (Math.cos(Math.PI * pos) - 1);
	    },
	    easeInOutQuint: function easeInOutQuint(pos) {
	      if ((pos /= 0.5) < 1) {
	        return 0.5 * Math.pow(pos, 5);
	      }
	      return 0.5 * (Math.pow(pos - 2, 5) + 2);
	    }
	  };
	
	  function tick() {
	    currentTime += 1 / 60;
	
	    var p = currentTime / time;
	    var t = easingEquations[easing](p);
	
	    if (p < 1) {
	      requestAnimFrame(tick);
	
	      window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
	    } else {
	      window.scrollTo(0, scrollTargetY);
	    }
	  }
	
	  tick();
	}

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-93f9805a898912b91995.js